import { PlatformSlug } from 'constants/consts'
import { getFeatureConfig, isFeatureAvailable } from 'platformConfig'

export type BlogPagesConfig = {
  successStories: boolean
  studyGuides: boolean
}

export const BLOG_PAGES_CONFIG: Partial<Record<PlatformSlug, BlogPagesConfig>> = {
  [PlatformSlug.DATBooster]: { successStories: true, studyGuides: true },
  [PlatformSlug.OATBooster]: { successStories: true, studyGuides: true },
  [PlatformSlug.DATCrusher]: { successStories: true, studyGuides: true },
  [PlatformSlug.INBDEBooster]: { successStories: true, studyGuides: true },
  [PlatformSlug.CasperBooster]: { successStories: false, studyGuides: true },
  [PlatformSlug.NBDHEBooster]: { successStories: false, studyGuides: true },
  [PlatformSlug.NDEBCrusher]: { successStories: false, studyGuides: true },
  [PlatformSlug.CARSBooster]: { successStories: false, studyGuides: true },
  [PlatformSlug.GREBooster]: { successStories: false, studyGuides: true },
  [PlatformSlug.NBEOPartOne]: { successStories: false, studyGuides: true },
  [PlatformSlug.DLOSCE]: { successStories: false, studyGuides: true },
}

export const getBlogPagesConfig = (slug?: PlatformSlug) => getFeatureConfig(BLOG_PAGES_CONFIG, slug)
export const isBlogPagesAvailable = (slug?: PlatformSlug) => isFeatureAvailable(BLOG_PAGES_CONFIG, slug)
